module.exports = __webpack_public_path__ + "static/media/procedure.31d8233c.jpg";